export interface DetailedBullet {
  title: string
  detail: string
}

export interface Bonus {
  id: string
  title: string
  subtitle: string
  /** Reference value in USD cents, shown struck through next to "Included free" */
  referenceValueCents?: number
  intro?: string
  bulletsIntro?: string
  bullets?: string[]
  detailedBullets?: DetailedBullet[]
  secondaryBulletsIntro?: string
  secondaryBullets?: string[]
  secondaryNote?: string
  systemLabel?: string
  system?: string
  result?: string
  closing?: string[]
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: 'Dental Anatomy & Tooth Identification Flashcards',
    subtitle: 'Fast, Accurate Tooth Recognition Before Every Clinical Session',
    referenceValueCents: 14990,
    intro:
      'Printable flashcards to drill tooth identification and dental anatomy: every permanent and primary tooth with a clear visual on the front and the answer and teaching notes on the back.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Universal, FDI & Palmer notation',
      'Crown & root features',
      'Surfaces, cusps & grooves',
      'Contact areas & root number',
      'Key identifying traits',
      'Eruption dates review cards',
      'Dental arches & occlusion landmarks',
      'Oral anatomy structures',
      'Beginner, standard & advanced decks',
    ],
    result: 'Help students recognize every tooth quickly and accurately.',
  },
  {
    id: '02',
    title: 'Clinical Demonstration Lesson Scripts',
    subtitle: 'Run a Polished Demonstration Without Preparing From Scratch',
    referenceValueCents: 9990,
    intro:
      'Word-for-word lesson scripts for core clinical procedures, each with talking points, the demonstration sequence, what students must observe, common errors to correct, student practice and a quick check.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Patient greeting & medical history review',
      'Infection control & operatory setup',
      'Intraoral & extraoral examination',
      'Charting',
      'Rubber dam placement',
      'Local anesthesia demonstration',
      'Cavity preparation & restoration steps',
      'Periodontal probing & patient instructions',
    ],
    result: 'Teach every demonstration with the confidence of a script that already works.',
  },
  {
    id: '03',
    title: 'Typodont & Simulation Lab Drills',
    subtitle: 'Keep Every Lab Session Active, Practical and Safe',
    referenceValueCents: 7990,
    intro:
      'Short, ready-to-run drills for preclinical simulation labs, each with timing (5–20 minutes), materials, setup, steps, evaluation points and easy / standard / advanced variations.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Mirror-vision & indirect vision exercises',
      'Fulcrum & finger-rest practice',
      'Operator & patient positioning',
      'Handpiece control on practice blocks',
      'Cavity outlines on typodont teeth',
      'Matrix & wedge placement',
      'Instrument grasp & transfer',
      'Probing on manikins & timed operatory setup',
    ],
    result: 'Fill every lab session with practice that moves students forward.',
  },
  {
    id: '04',
    title: 'Dental Radiograph Interpretation Practice Cards',
    subtitle: 'Teach Students to Read Every Image Methodically',
    referenceValueCents: 6990,
    intro:
      'Printable practice cards to build confident radiographic interpretation, each with a described case, guided questions, the systematic reading sequence and the answer key, at beginner, standard and advanced levels.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Normal anatomy on periapical, bitewing & panoramic views',
      'Radiolucent vs. radiopaque findings',
      'Interproximal caries depth',
      'Periodontal bone levels',
      'Periapical radiolucencies',
      'Restorations on radiographs',
      'Common technique errors',
    ],
    result: 'Help students read radiographs with a clear, systematic method.',
  },
  {
    id: '05',
    title: 'Clinical Competency Rubrics & Certificates',
    subtitle: 'Evaluate Objectively and Document Every Competency Achieved',
    referenceValueCents: 5990,
    intro:
      'Ready-to-use competency rubrics scored on clear beginner, standard and advanced criteria, plus practical exam checklists, clinical requirement trackers, student progress logs and elegant completion certificates.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Infection control & operatory setup',
      'Patient assessment & charting',
      'Radiographic technique',
      'Local anesthesia',
      'Rubber dam isolation',
      'Cavity preparation & restoration',
      'Periodontal assessment & scaling',
      'Professionalism, communication & certificates',
    ],
    result: 'Assess every student fairly and give structured feedback at every level.',
  },
]
